import { PuzzleSessionController } from './PuzzleSessionController';
/** R5: how long the position before the opponent's move stays still before that move plays. */
export const SETUP_PAUSE_MS = 450;
/** Timers are effects, never the source of chess correctness. */
export class PuzzleOrchestrator {
  private timer?: ReturnType<typeof setTimeout>;
  private unsubscribe: () => void;
  constructor(
    private controller: PuzzleSessionController,
    private reduced = false,
  ) {
    this.unsubscribe = controller.subscribe(() => this.sync());
    this.sync();
  }
  private sync() {
    clearTimeout(this.timer);
    const { status, session } = this.controller.snapshot,
      generation = session.generation;
    if (status === 'preparing')
      this.timer = setTimeout(
        () => this.controller.playSetup(generation),
        this.reduced ? 0 : SETUP_PAUSE_MS,
      );
    if (status === 'auto-reply-delay')
      this.timer = setTimeout(() => this.controller.reply(generation), this.reduced ? 0 : 190);
    if (status === 'auto-reply-animating')
      this.timer = setTimeout(
        () => this.controller.animationDone(generation),
        this.reduced ? 0 : 160,
      );
  }
  dispose() {
    clearTimeout(this.timer);
    this.unsubscribe();
  }
}
